export default __webpack_public_path__ + "static/media/error-404.73bb52e5.svg";